import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchUserData } from "./environmentAPI";

export const initialState = {
    status: "idle",
    userData: null,
    userDataLoaded: false
};

export const fetchUserDetails = createAsyncThunk(
    'app/fetchUserData',
    async () => {
        const response = await fetchUserData();
        return response.data;
    }
);

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
          .addCase(fetchUserDetails.pending, (state) => ({
            ...state,
            status: "loading",
            userDataLoaded: false
          }))
          .addCase(fetchUserDetails.fulfilled, (state, action) => ({
            ...state,
            status: "idle",
            userData: action.payload,
            userDataLoaded: true
          }))
          .addCase(fetchUserDetails.rejected, (state) => ({
            ...state,
            failed: true,
            status: "loading",
            userDataLoaded: true
          }));
    },
});

export const getUserData = (state) => state.user.userData;
export const getUserDataLoaded = (state) => state.user.userDataLoaded;

export default userSlice.reducer;
